<script setup>
import AgentLayout from "@/views/layouts/AgentLayout.vue";
import MessagesAnalytics from "@/components/MessagesAnalytics.vue";
</script>

<template>
  <AgentLayout>
    <MessagesAnalytics />
  </AgentLayout>
</template>
